import { ProductWarehouseStatus } from 'features/inventory/products/constants';
import { StatusOption } from 'shared/types/general';

export const buildContractLineStatusOptions = (
  statuses: StatusOption[] = [],
  hasStockQuantity: boolean,
  selectedStatus: number | string | null | undefined,
  translate: (key: string) => string
): StatusOption[] => {
  const availableStatuses = statuses.length
    ? statuses
    : Object.entries(ProductWarehouseStatus).map(([key, value]) => ({
        value: Number(value),
        display_name: key
      }));

  const selectedStatusValue = selectedStatus == null ? null : Number(selectedStatus);

  const filtered = hasStockQuantity
    ? availableStatuses.filter(
        (option) =>
          option.value !== ProductWarehouseStatus.DECOMMISSIONED ||
          (selectedStatusValue !== null && Number(option.value) === selectedStatusValue)
      )
    : availableStatuses;

  return filtered.map((option) => {
    const keyName = option.display_name ?? String(option.value);
    const label = translate(`entities.product.status_options.${keyName}`);

    return {
      ...option,
      display_name: label
    };
  });
};
